export function idle(timeOut,url) {
  if (typeof window !== 'undefined') {
    var t;
    window.onload = resetTimer;
    window.onmousemove = resetTimer;
    window.onmousedown = resetTimer; 
    window.ontouchstart = resetTimer; 
    window.onclick = resetTimer; 
    window.addEventListener('scroll', resetTimer, true);

    function resetTimer() {
      clearTimeout(t);
      t = setTimeout(function () {
        window.location.href = url;
      }, timeOut); 
    }
  }
}